/**
 * @type {Object}
 */
const CssLayers = {
  INLINE_TOOLBAR: 9000,
  INLINE_TOOLBAR_LINK_INPUT: 9001,
  SIDE_TOOLBAR: 9002,
  SIDE_CONTENT_CIRCLE: 9004,
  MENTIONS: 9004,
};

export default CssLayers;
